var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-move-section w-full"},[_c('div',{staticClass:"page-move prev w-full f-b f-gry",class:{ 'is-show': !_vm.prev },on:{"click":_vm.goPrev}},[_vm._v(" "+_vm._s(_vm.prevText)+" ")]),_c('div',{staticClass:"page-move next w-full f-b f-wh",on:{"click":_vm.goNext}},[_vm._v(" "+_vm._s(_vm.nextText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }